import axiosInstance from "./axiosInstance";

// GET all Home
export const getHome = async () => {
  try {
    const response = await axiosInstance.get("/home");
    return response.data.data; // assuming API returns {status, data}
  } catch (error) {
    console.error("Failed to fetch Home:", error);
    throw error;
  }
};

// GET all ProductImage
export const getProdsuctImage = async () => {
  try {
    const response = await axiosInstance.get("/productImage");
    return response.data.data; // assuming API returns {status, data}
  } catch (error) {
    console.error("Failed to fetch productImages:", error);
    throw error;
  }
};

// GET all ProductImage
export const getAnimationImage = async () => {
  try {
    const response = await axiosInstance.get("/footerimage");
    return response.data.data; // assuming API returns {status, data}
  } catch (error) {
    console.error("Failed to fetch animationImages:", error);
    throw error;
  }
};

